import useClipboard from "vue-clipboard3";
import { Toast } from "vant"
const { toClipboard } = useClipboard();
const copy = async (val) => {
    try {
        await toClipboard(val);
        Toast.success('复制成功');
    } catch (e) {
        // console.log(e);
        Toast.fail('复制失败');
    }
};

export default copy;